<script>
  export let text;
  export let href;
  export let compact = false;
</script>

<style>
  .wrapper {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-self: start;
  }

  .icon {
    padding: 20px 0;
  }

  .icon.compact {
    padding: 10px 0;
  }

  @media only screen and (min-width: 600px) {
    .wrapper {
      flex-direction: row;
      align-items: center;
    }

    .icon {
      padding-right: 20px;
    }

    .icon.compact {
      padding-right: 20px;
    }
  }
</style>

<div class="wrapper">
  <div class="icon" class:compact>
    <img width="33" height="41" src="images/pdf.png" alt="download pdf" />
  </div>
  <a {href} download>{text}</a>
</div>
